import { type FC } from "react";

import { BasicTooltip } from "../../Tooltip";
import { type ColumnType } from "../validation/parseColumnType";
import { ColumnTypeIcon } from "./ColumnTypeIcon";

export const ColumnTypeIconWithTooltip: FC<{ fieldType: ColumnType | undefined }> = ({
	fieldType,
}) => {
	/* IMPORTANT: Do *NOT* use `Portal` here! If you do it will appear *BEHIND* the
	 * column header dropdown menu. */
	return (
		<BasicTooltip
			withPortal={false}
			contentProps={{ side: "left", sideOffset: 12 }}
			content={<>{fieldType} field</>}
		>
			<ColumnTypeIcon className="fill-icon-default" fieldType={fieldType} />
		</BasicTooltip>
	);
};
